module.exports = __webpack_public_path__ + "img/Logo_Colltex.cc3c2d9b.svg";